import React from 'react';

import './App.css';
import LoginButton from './components/LoginButton';
import Dashboard from './components/Dashboard';
import Welcome from './components/Welcome';
import LogoutButton from './components/LogoutButton';




//App.js components show up even if the user is logged out

function App() {
  return (
    <>
    <body class = "background">

    <div class="topnav">
      
    
  <LogoutButton />
</div>
      
    
  
  
    <div class="wrapper">
    
  
  <div class="sidebar">
  
  <nav class="nav flex-column">
  <a class = "nav-link active"  href = "https://metrohacks.org/empowher/"><img class = "logo" src = "empowher-assets/img/logo.png"></img></a>
  <a class="nav-link active" href="https://metrohacks.org/empowher/">HOME</a>
  <a class="nav-link" href="https://metrohacks.org/empowher/about.html">ABOUT</a>
  <a class="nav-link" href="https://metrohacks.org/empowher/competition.html">COMPETITION</a>
  <a class="nav-link" href="https://metrohacks.org/empowher/workshops.html">WORKSHOPS</a>
  <a class="nav-link" href="https://metrohacks-empowher-participant-portal.github.io/NewsletterArchive.html">NEWSLETTER ARCHIVE</a>
  <a class="nav-link" href="https://metrohacks-empowher-participant-portal.github.io/getting-started.html">GETTING STARTED</a>
  <a class="nav-link disabled" href="#"></a>
  
</nav>
      
  </div>
  
  <div class="main_container">
  <Welcome />

 
<Dashboard />
 





 <LoginButton/>
    
  </div>
</div>


  
 
  

  
    
    
    
    
    
    
    
    
    
    
   

    
    
    </body>
    
    

    </>
  );
}

export default App;
